export const SET_HELPS = 'SET_HELPS';
export const SET_HELP = 'SET_HELP';
export const ADD_HELP = 'ADD_HELP';
export const ADD_HELPS = 'ADD_HELPS';
export const UPDATE_HELP = 'UPDATE_HELP';
export const REMOVE_HELP = 'REMOVE_HELP';
export const CLEAR_HELP = 'CLEAR_HELP';
export const CLEAR_HELPS = 'CLEAR_HELPS';
